import { supabase } from "@/integrations/supabase/client";

/**
 * Enviar notificação de prova agendada para o cliente
 * Pode ser expandido para enviar email, SMS, etc.
 */
export async function notificarProvaAgendada(
  clienteEmail: string,
  clienteNome: string,
  dataProva: string,
  horaProva: string,
  localProva: string,
  pedidoNumero: string
): Promise<{ ok: boolean; message?: string }> {
  try {
    // Mapeamento de locais para mensagem amigável
    const locaisMap: Record<string, string> = {
      atelier: "no nosso ateliê",
      cliente: "na sua residência",
      video: "por vídeo chamada",
    };

    const localTexto = locaisMap[localProva] || localProva;

    // Formatar data para exibição
    const dataFormatada = new Date(dataProva).toLocaleDateString("pt-BR", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const mensagem = `Olá ${clienteNome}!

Sua prova de ajustes foi agendada com sucesso! 🎉

📅 Data: ${dataFormatada}
🕐 Horário: ${horaProva}
📍 Local: ${localTexto}
📦 Pedido: #${pedidoNumero}

Se precisar remarcação, entre em contato conosco!

Obrigada por confiar no nosso trabalho!`;

    console.log("📧 Notificação de prova agendada:", {
      cliente: clienteNome,
      email: clienteEmail,
      data: dataProva,
      hora: horaProva,
      local: localProva,
    });

    // Aqui você poderia integrar com um serviço de email real
    // Por enquanto, apenas registramos o log e retornamos sucesso
    // Futura integração: SendGrid, Nodemailer, etc.

    return {
      ok: true,
      message: `Notificação enviada para ${clienteEmail}`,
    };
  } catch (error) {
    console.error("Erro ao enviar notificação de prova:", error);
    return {
      ok: false,
      message: "Erro ao enviar notificação",
    };
  }
}

/**
 * Enviar lembrete de prova agendada (para usar antes de uma prova)
 */
export async function enviarLembreteProva(
  clienteEmail: string,
  clienteNome: string,
  dataProva: string,
  horaProva: string,
  pedidoNumero: string
): Promise<{ ok: boolean; message?: string }> {
  try {
    const mensagem = `Olá ${clienteNome}!

Lembrete: Sua prova está agendada para amanhã! ⏰

🕐 Horário: ${horaProva}
📦 Pedido: #${pedidoNumero}

Nos vemos lá! 😊`;

    console.log("📧 Lembrete de prova:", {
      cliente: clienteNome,
      email: clienteEmail,
      data: dataProva,
    });

    return {
      ok: true,
      message: `Lembrete enviado para ${clienteEmail}`,
    };
  } catch (error) {
    console.error("Erro ao enviar lembrete de prova:", error);
    return {
      ok: false,
      message: "Erro ao enviar lembrete",
    };
  }
}

/**
 * Registrar notificação no histórico (para futura implementação de dashboard)
 */
export async function registrarNotificacao(
  empresaId: string,
  tipoNotificacao: "prova_agendada" | "prova_lembrete" | "prova_cancelada",
  cliente: {
    id: string;
    nome: string;
    email: string;
  },
  pedidoNumero: string,
  dados: Record<string, any>
): Promise<{ ok: boolean; error?: string }> {
  try {
    // Aqui você poderia salvar no banco de dados um registro de notificações
    // Para auditoria e histórico
    console.log("📝 Notificação registrada:", {
      tipo: tipoNotificacao,
      cliente: cliente.nome,
      pedido: pedidoNumero,
      timestamp: new Date().toISOString(),
    });

    return { ok: true };
  } catch (error: any) {
    console.error("Erro ao registrar notificação:", error);
    return {
      ok: false,
      error: error?.message ?? "Erro ao registrar notificação",
    };
  }
}
